import EventBus from '../services/event-bus';

const Loader = {
    mutex: 0,
    shown: false,
    showTimer: 0,
    autoHideDelay: 120, // In Seconds

    show(label) {
        if (!this.mutex) {
            this.shown = true;

            this.showTimer = setTimeout(() => {
                this.shown = this.autoHide();
                this.showTimer = 0;

                EventBus.$emit('backdrop.show', {'label': label});
            }, 300);
        }

        ++this.mutex;
    },

    hide(force) {
        if (this.shown && (force || --this.mutex <= 0)) {
            this.mutex = 0;
            this.shown = false;

            if (this.showTimer > 0) {
                clearTimeout(this.showTimer);

                this.showTimer = 0;
            } else {
                EventBus.$emit('backdrop.hide');
            }
        }
    },


    /**
     * Force auto hide after 2 minutes to give back access to UI
     */
    autoHide() {
        let uid = 1 + Math.floor(Math.random() * 10000);

        setTimeout(() => {
            if (this.shown === uid) {
                this.hide(true);

                console.error('Loader auto-hide delay reached.', uid);
            }
        }, this.autoHideDelay * 1000);

        return uid;
    }
};

export default Loader;


// WEBPACK FOOTER //
// ./resources/assets/js/services/loader.js